"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DynamicLoadBaseImpl = void 0;
class DynamicLoadBaseImpl {
}
exports.DynamicLoadBaseImpl = DynamicLoadBaseImpl;
//# sourceMappingURL=dynamicLoadInterfaces.js.map